import React, { useState, useEffect, useMemo } from "react";
import {
  Grid,
  TextField,
  Button,
  Typography,
  IconButton,
  Snackbar,
  Alert,
  Box,
  Modal,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import axiosInstance from "../../../API/axiosInstance";

const FleetDailyReport = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const token = localStorage.getItem("token");
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [showErrorSnackbar, setShowErrorSnackbar] = useState(false);
  const [open, setOpen] = useState(false);
 const userData = useMemo(() => {
    return location.state || {};
  }, [location.state]);
  const [formData, setFormData] = useState({
    id: "",
    headerLabel: "",
    description: "",
    startTime: "",
    endTime: "",
    url: "",
    image: "",
  });

  // Load user data into form when component mounts
  useEffect(() => {
    if (userData) {
      setFormData({
        id: userData.id || "",
        headerLabel: userData.headerLine || "",
        description: userData.description || "",
        startTime: userData.startTime || "",
        endTime: userData.endTime || "",
        url: userData.url || "",
        image: userData.image || "",
      });
    }
  }, [userData]);

  const handleBackToDashboard = () => {
    navigate("/notificationList");

  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await axiosInstance.post(
        "/users/notification/update",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.status === 200) {
        setOpen(true);
        setTimeout(() => {
          setOpen(false);
          navigate("/notificationList");
        }, 3000);
      } else {
        setSnackbarMessage(response.data?.message || "Error updating notification");
        setShowErrorSnackbar(true);
      }
    } catch (error) {
      console.error("API call error:", error);
      setSnackbarMessage("Failed to update notification. Please try again.");
      setShowErrorSnackbar(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleFileUpload = async (event: any) => {
    const file = event.target.files[0];
    if (!file) return;

    const formDataObj = new FormData();
    formDataObj.append("file", file);

    try {
      const response = await axiosInstance.post(
        "/file/upload-image",
        formDataObj,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response?.data?.data?.fileId) {
        setFormData((prevData) => ({ ...prevData, image: response.data.data.fileId }));
      }
    } catch (error) {
      console.error("File upload failed:", error);
      setSnackbarMessage("File upload failed. Please try again.");
      setShowErrorSnackbar(true);
    }
  };

  return (
    <div>
      
      <div className="flex bg-white min-h-80 box-shadow p-3 rounded-xl mx-16 mt-10">
        <div className="w-full">
          <Grid container spacing={5}>
            <Grid item md={4}>
              <div className="flex ml-4">
                <h2 className="text-center ml-2 mx-1 mt-2 font-semibold text-2xl text-black pb-2">
                  <IconButton onClick={handleBackToDashboard}>
                    <ArrowBackIcon />
                  </IconButton>
                  Edit Notification
                </h2>
              </div>
            </Grid>
          </Grid>
          <hr className="my-4" />

          <form onSubmit={handleSubmit} className="p-8">
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="Header Label"
                  name="headerLabel"
                  value={formData.headerLabel}
                  onChange={handleChange}
                  variant="standard"
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="Description"
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  variant="standard"
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="URL"
                  name="url"
                  value={formData.url}
                  onChange={handleChange}
                  variant="standard"
                />
              </Grid>
            </Grid>

            <Grid container spacing={2} className="pt-10">
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="Start Time"
                  name="startTime"
                  type="datetime-local"
                  InputLabelProps={{ shrink: true }}
                  value={formData.startTime}
                  onChange={handleChange}
                  variant="standard"
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  label="End Time"
                  name="endTime"
                  type="datetime-local"
                  InputLabelProps={{ shrink: true }}
                  value={formData.endTime}
                  onChange={handleChange}
                  variant="standard"
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  label="Upload Image"
                  InputLabelProps={{ shrink: true }}
                  type="file"
                  onChange={handleFileUpload}
                  sx={{
                    borderBottom: "1px solid",
                    "& fieldset": { border: "none" },
                    "& .MuiInputBase-input": { padding: "12.5px 9px" },
                  }}
                />
                {formData.image && <p>Image uploaded successfully!</p>}
              </Grid>
            </Grid>

            <Grid container spacing={2} className="pt-10 flex justify-end">
              <Grid item xs={3}>
                <Button
                  type="submit"
                  disabled={isSubmitting}
                  style={{
                    backgroundColor: "#000",
                    padding: "5px 18px",
                    color: "#fff",
                    borderRadius: "40px",
                    width: "100%",
                    textTransform: "none",
                    fontSize: "16px",
                  }}
                >
                  {isSubmitting ? "Updating..." : "Update Notification"}
                </Button>
              </Grid>
            </Grid>
          </form>
        </div>
      </div>
      <Modal open={open} onClose={() => setOpen(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 350,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: "8px",
            textAlign: "center",
          }}
        >
           <IconButton
            sx={{ position: "absolute", top: 8, right: 8 }}
            onClick={() => setOpen(false)}
          >
            <CloseIcon />
          </IconButton>
          <Box
            sx={{
              width: 60,
              height: 60,
              backgroundColor: "#00C853",
              borderRadius: "50%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              margin: "auto",
            }}
          >
            <Typography sx={{ fontSize: 40, color: "white" }}>✔</Typography>
          </Box>
          <Typography variant="h6" sx={{ mt: 2 }}>
           Notification Update  Successfully!
          </Typography>
          <Button
            variant="contained"
            sx={{ mt: 3, backgroundColor: "#000", color: "#fff", borderRadius:'40px' }}
            onClick={() => setOpen(false)}
          >
            Continue to Dashboard
          </Button>
        </Box>
      </Modal>
      <Snackbar open={showErrorSnackbar} autoHideDuration={6000} onClose={() => setShowErrorSnackbar(false)}>
        <Alert severity="error">{snackbarMessage}</Alert>
      </Snackbar>
    </div>
  );
};

export default FleetDailyReport;
